import TextLink from "@/components/text-link";
import { useTranslations } from "@/hooks/use-translations";
import { login, register } from "@/routes";
import { AuthProcess } from "@/types";

type SwitchAuthProcessLinkProps = {
  authProcess: AuthProcess;
};

export default function SwitchAuthProcessLink({
  authProcess,
}: SwitchAuthProcessLinkProps) {
  const { __ } = useTranslations();

  return (
    <div className="mb-2 text-center text-muted-foreground text-sm">
      {authProcess === AuthProcess.LogIn && (
        <>
          {__("auth.log_in_page.not_registered_q")}{" "}
          <TextLink href={register()} tabIndex={0}>
            {__("auth.log_in_page.sign_up")}
          </TextLink>
        </>
      )}
      {authProcess === AuthProcess.Register && (
        <>
          {__("auth.register_page.have_account_q")}{" "}
          <TextLink href={login()} tabIndex={0}>
            {__("auth.log_in")}
          </TextLink>
        </>
      )}
    </div>
  );
}
